import { LocalStorage } from "wize-admin";

import { SecurityService } from "@/core/services";

import { Constants } from "@/core/utils";

const state = {
  refreshToken: LocalStorage.getRefreshToken(),
  accessToken: LocalStorage.getAccessToken(),
  user: LocalStorage.getUser(),
  ssoState: LocalStorage.getSsoState(),
  isTokenValid: false,
};

const getters = {
  isAuthenticated: (state) => state.user && state.user.email,
  getUser: (state) => state.user,
  getSsoState: (state) => state.ssoState,
  isTokenValid: (state) => state.isTokenValid,
  isSuperAdmin: (state) => state.user && state.user.profile == Constants.ProfileTypes.SUPER_ADMINISTRATOR.key,
  isAdmin: (state) => state.user && state.user.profile == Constants.ProfileTypes.ADMINISTRATOR.key
};

const actions = {
  setAccessToken({ commit }, payload) {
    commit("isTokenValid", true);
    commit("accessToken", payload);
  },
  checkValidToken({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      SecurityService.isValidToken()
        .then((response) => {
          if (response) {
            commit("isTokenValid", true);
            resolve();
          }
        })
        .catch((err) => {
          reject(err);
          dispatch("logout");
        });
    });
  },
  setUser({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      SecurityService.getUserInfo().then((resp) => {
        let user = { ...resp.payload };
        user.name = user.firstName + " " + user.lastName
        commit('user', user);
        // abilities.defineAbilitiesForPlan(user.currentPlan)
        resolve(user)
      }).catch((ex) => {
        console.error(ex);
        dispatch('logout');
        reject();
      })
    });
  },
  setAuthInfo({ commit }, payload) {
    const { accessToken, user, refreshToken } = payload;
    commit("accessToken", accessToken);
    commit("user", user);
    commit("refreshToken", refreshToken);
  },
  logout({ commit }) {
    return new Promise((resolve) => {
      commit("accessToken", null);
      commit("user", null);
      commit("refreshToken", null);
      resolve();
    });
  },
};

const mutations = {
  isTokenValid(state, value) {
    state.isTokenValid = value;
  },
  accessToken(state, value) {
    value
      ? LocalStorage.setAccessToken(value)
      : LocalStorage.clearAccessToken();
    state.accessToken = value;
  },
  refreshToken(state, value) {
    value
      ? LocalStorage.setRefreshToken(value)
      : LocalStorage.clearRefreshToken();
    state.refreshToken = value;
  },
  user(state, value) {
    value ? LocalStorage.setUser(value) : LocalStorage.clearUser();
    state.user = value;
  },
  ssoState(state, value) {
    value ? LocalStorage.setSsoState(value) : LocalStorage.clearSsoState();
    state.ssoState = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
